export default __webpack_public_path__ + "static/media/NIAS0540.34I-40174_-23845_0.28dd2700.jpg";